// extracted by mini-css-extract-plugin
module.exports = {"changeLogList":"ChangeLog_changeLogList__3HyJ2"};